import $ from 'jquery';
import 'jquery-match-height';

const MatchHeight = () => {
   // Match heights by row (only matches elements in the same row)
   $('[data-mh]').matchHeight({
      byRow: true
   });

};
export default MatchHeight;